import { ThisConnector } from '../../../../api/connector'

export interface ApiCredentials {
  apiKey: undefined | string
  serviceKey: undefined | string
  userUid: undefined | string
  token: undefined | string
}

export async function getApiCredentials(
  this: ThisConnector,
  {
    organizationUuid
  }: {
    organizationUuid: string
  }
) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { api_key } = await this.connector.get(
    `/${organizationUuid}/users/keys/apikey`
  )

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const { service_key, user_uid, token } = await this.connector.get(
    `/profile/servicekey`
  )

  const response: ApiCredentials = {
    apiKey: api_key,
    serviceKey: service_key,
    userUid: user_uid,
    token
  }

  return response
}
